<template>
  <a-modal :open="open" @cancel="closeForm">
    <h2>Выберите отчет для скачивания</h2>
    <a-divider style="margin: 16px 0" />

    <div v-for="passing in passings" :key="passing.code" class="download-list">
      <div v-if="passing.status === 'finished'">
        <div v-if="!reportIsGenerating">
          <div class="download-header date-header">
            <div>
              {{ passing.finished_at }}
            </div>
            <div class="link-green">
              <PlusOutlined />
              <span @click="() => setActiveModal(passing)" class="new-report-types-button">
                Получить другие отчеты
              </span>
            </div>
          </div>

          <template v-if="passing.report_type === 'management'">
            <a-card style="padding: 5px">
              <div class="download-header">
                <div>
                  {{ getReportName(passing.report_type) + ' Отчет для сотрудника'}}
                </div>
                <div @click="downloadReport(passing.code, 'employee')">
                  <DownloadOutlined style="color: var(--main-green)" />
                </div>
              </div>
            </a-card>

            <a-card style="padding: 5px">
              <div class="download-header">
                <div>
                  {{  getReportName(passing.report_type) + ' Отчет для заказчика'}}
                </div>
                <div @click="downloadReport(passing.code, 'employer')">
                  <DownloadOutlined style="color: var(--main-green)" />
                </div>
              </div>
            </a-card>
          </template>

          <template v-else>
            <a-card style="padding: 5px">
              <div class="download-header">
                <div>
                  {{  getReportName(passing.report_type) }}
                </div>
                <div @click="downloadReport(passing.code, passing.report_type)">
                  <DownloadOutlined style="color: var(--main-green)" />
                </div>
              </div>
            </a-card>
          </template>

          <template v-for="differentReport in passing.related_passings" :key="differentReport.code">
            <template v-if="differentReport.report_type === 'management'">
              <a-card style="padding: 5px">
                <div class="download-header">
                  <div>
                    {{ getReportName(differentReport.report_type) + ' Отчет для сотрудника'}}
                  </div>
                  <div @click="downloadReport(differentReport.code, 'employee')">
                    <DownloadOutlined style="color: var(--main-green)" />
                  </div>
                </div>
              </a-card>

              <a-card style="padding: 5px">
                <div class="download-header">
                  <div>
                    {{  getReportName(differentReport.report_type) + ' Отчет для заказчика'}}
                  </div>
                  <div @click="downloadReport(differentReport.code, 'employer')">
                    <DownloadOutlined style="color: var(--main-green)" />
                  </div>
                </div>
              </a-card>
            </template>

            <a-card v-else>
              <a-card style="padding: 5px">
                <div class="download-header">
                  <div>
                    {{  getReportName(differentReport.report_type) }}
                  </div>
                  <div @click="downloadReport(differentReport.code, 'employer')">
                    <DownloadOutlined style="color: var(--main-green)" />
                  </div>
                </div>
              </a-card>
            </a-card>
          </template>
        </div>
      </div>
      <div v-if="reportIsGenerating" class="spin">
        <a-spin />
      </div>
    </div>
    <div v-if="!passings.length" class="spin">
      <p>Нет отчетов</p>
    </div>

    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>


import {useRouter} from "vue-router";
import {DownOutlined, PlusOutlined, DownloadOutlined} from "@ant-design/icons-vue";
import {computed} from "@vue/reactivity";
import {useStore} from "vuex";

import getReportName from "../../mixins/getReportName";
import {ref} from "@vue/runtime-core";

export default {
  methods: {getReportName},
  components: {PlusOutlined, DownOutlined, DownloadOutlined},
  props: {
    open: Boolean,
    passings: Array,
  },
  emits: ['close', 'getAdditionalReports'],
  setup(props, context) {
    const router = useRouter();

    const columns = computed(() => [
      {
        title: 'Событие',
        dataIndex: 'name',
        sorter: false,
        width: 250,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        sorter: false,
        width: 90,
      },
      {
        title: 'Дата назначения',
        dataIndex: 'started_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 120,
      },
    ]);

    const store = useStore();

    const closeForm = () => {
      context.emit('close');
    }

    const setActiveModal = (passing) => {
      context.emit('getAdditionalReports', passing);
    }

    const reportIsGenerating = ref(false);

    const downloadReport = (code, type) => {
      reportIsGenerating.value = true;

      store.dispatch("group/getReport", {
        passing: [code],
        type: type,
      }).finally(() => {
        reportIsGenerating.value = false;
      })
    };

    console.log(props.passings)

    return {
      closeForm,
      router,
      columns,
      setActiveModal,
      reportIsGenerating,
      downloadReport
    }
  }
}
</script>

<style scoped lang="scss">
.tests-list {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .secondary-button {
    margin-top: 16px;
  }
}

.test-details-card-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    justify-content: center;
  }
}

.test-title {
  font-weight: 600;
}

.test-image-wrapper img {
  width: 100px;
  max-height: 140px;
  object-fit: cover;
}

.action-buttons {
  justify-content: flex-end;
  display: flex;
  gap: 8px;

  @media(max-width: $mobile-breakpoint) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
}

.link-green {
  color: var(--main-green);
}

.link-green:hover {
  color: var(--hover-green);
}

.download-header {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
}

:deep(.ant-card .ant-card-body) {
  padding: 5px !important;
}

.spin {
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  min-height: 20vh;
}

h2 {
  margin: 0;
}

.date-header {
  margin-bottom: 5px;
}

</style>